import React, {PropTypes} from "react";

const Banner = (props) => {

  return (<header>
      <div className="jumbotron banner"
           style={{height: '80px', paddingTop: 20, paddingBottom: 10, marginBottom: 5}}
      >
        <div className="container">
          <div className="row">
            <div className="col-xs-12">
              <h1 className="text-center">{props.name}</h1>
            </div>
          </div>
        </div>
      </div>
    </header>
  );

}

Banner.proptypes = {};

export default Banner;



/** WEBPACK FOOTER **
 ** ./src/components/common/Banner.js
 **/